import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {ThemeService} from "@services/theme.service";


interface LegendItem {
  color: 'green' | 'yellow' | 'red' | 'blue' | 'gray';
  label: string;
}

@Component({
  selector: 'msf-tile-map-legend',
  standalone: true,
  templateUrl: './tile-map-legend.html',
  styleUrl: './tile-map-legend.scss',
  imports: [CommonModule, TranslateModule]
})
export class TileMapLegend {

  @Input() items: LegendItem[] = [
    { color: 'green', label: 'tile_map.legend.no_alerts' },
    { color: 'yellow', label: 'tile_map.legend.one_alert' },
    { color: 'red', label: 'tile_map.legend.multiple_alerts' },
    { color: 'gray', label: 'tile_map.legend.no_data' }
  ];

  constructor(private themeService: ThemeService) {}

  get isDarkTheme(): boolean {
    return this.themeService.isDarkMode();
  }

}
